export const MeetingTypes = {
  COFFEE_GROUP: 'COFFEE_GROUP',
  COFFEE_ONE_BY_ONE: 'COFFEE_ONE_BY_ONE',
  LIVE: 'LIVE',
  ZOOM_GROUP: 'ZOOM_GROUP',
  ZOOM_ONE_BY_ONE: 'ZOOM_ONE_BY_ONE'
};
